var exports = {
  "lm": "LanguageTab.module__notice___SFpCTE",
  "ut": "LanguageTab.module__noticeText___SFpCTE",
  "nf": "LanguageTab.module__link___SFpCTE",
  "XG": "LanguageTab.module__languageSelect___SFpCTE",
  "pK": "LanguageTab.module__languageControls___SFpCTE",
  "e5": "LanguageTab.module__timeControls___SFpCTE",
  "_9": "LanguageTab.module__languageOption___SFpCTE",
  "Ri": "LanguageTab.module__languageOptionMenu___SFpCTE",
  "l5": "LanguageTab.module__languageDetails___SFpCTE",
  "aX": "LanguageTab.module__languageCode___SFpCTE",
  "Eb": "LanguageTab.module__flagImage___SFpCTE",
  "TU": "LanguageTab.module__flagImageText___SFpCTE",
  "hx": "LanguageTab.module__languageOptionCompact___SFpCTE",
  "cL": "LanguageTab.module__languageName___SFpCTE",
  "X6": "LanguageTab.module__languageOptionSelected___SFpCTE",
  "rv": "LanguageTab.module__tooltipContent___SFpCTE",
  "HE": "LanguageTab.module__tooltipText___SFpCTE",
  "QT": "LanguageTab.module__switchWrapper___SFpCTE",
  "Kx": "LanguageTab.module__spellcheckHint___SFpCTE",
  "OO": "LanguageTab.module__spellcheckRestartBanner___SFpCTE",
  "Ru": "LanguageTab.module__dictionaryGrid___SFpCTE",
  "b": "LanguageTab.module__dictionaryRow___SFpCTE",
  "CG": "LanguageTab.module__dictionaryRowChecked___SFpCTE",
  "mj": "LanguageTab.module__dictionaryName___SFpCTE",
  "P": "LanguageTab.module__dictionaryTag___SFpCTE",
  "Wc": "LanguageTab.module__manualDictionaryBlock___SFpCTE",
  "uW": "LanguageTab.module__personalDictAddRow___SFpCTE",
  "bU": "LanguageTab.module__personalDictInput___SFpCTE",
  "rj": "LanguageTab.module__personalDictList___SFpCTE",
  "ze": "LanguageTab.module__personalDictChip___SFpCTE",
  "nm": "LanguageTab.module__personalDictChipRemove___SFpCTE",
  "ib": "LanguageTab.module__personalDictEmpty___SFpCTE",
};

module.exports = exports;
